export const SPECIAL_USER_EMAILS: readonly string[] = [
  'service@blackroom.cc',
  'kyllian.vinkler@gmail.com',
  'abdel@blackroom.cc',
  'corentin@blackroom.cc',
  'gaetan@blackroom.cc',
] as const;

export const normalizeEmail = (email: string) => email.trim().toLowerCase();

export const isEmailInList = (
  email: string | null | undefined,
  allowedEmails: readonly string[],
): boolean =>
  !!email &&
  allowedEmails.some(
    (allowedEmail) => normalizeEmail(allowedEmail) === normalizeEmail(email),
  );

export const isSpecialUserEmail = (email?: string | null): boolean =>
  isEmailInList(email, SPECIAL_USER_EMAILS);
